export function isSubscriptionStart(value) {
    return typeof value === 'function';
}
export function isSubscriptionHandler(value) {
    var _a;
    return (typeof value === 'object' &&
        typeof ((_a = value) === null || _a === void 0 ? void 0 : _a.unsubscribe) === 'function');
}
